export enum ColorsByHueType {
  hue = 'hue',
  tint = 'tint'
}

export interface ColorsByHueProps {
  name: string
  value: string
  label: string
  optionLabel: string
  optionValue: string
  type: ColorsByHueType
  expression: string
  percentage?: number
  tints?: ColorsByHueProps[]
}

export const paletteColors = {
  // D1 (2026-07-28): re-pointed to the Luma brand ramp (spec §3.3) — was heritage #e4610f.
  primary: '#ff5c00',
  secondary: '#0C0808',
  heritage: '#ff5c00',
  heritage100: '#ff5c00',
  heritage75: '#ff9052',
  heritage50: '#ffbb94',
  heritage25: '#ffe2d1',
  confidence: '#0C0808',
  confidence100: '#0C0808',
  confidence75: '#494646',
  confidence50: '#868484',
  confidence25: '#C2C1C1',
  collaboration: '#9C266E',
  collaboration100: '#9C266E',
  collaboration75: '#B55C92',
  collaboration50: '#CE93B7',
  collaboration25: '#E6C9DB',
  clientsuccess: '#F1B434',
  clientsuccess100: '#F1B434',
  clientsuccess75: '#F5C767',
  clientsuccess50: '#F8DA9A',
  clientsuccess25: '#FCECCC',
  sustainability: '#007377',
  sustainability100: '#007377',
  sustainability75: '#409699',
  sustainability50: '#80B9BB',
  sustainability25: '#BFDCDD',
  integrity: '#326295',
  integrity100: '#326295',
  integrity75: '#6589B0',
  integrity50: '#99B1CA',
  integrity25: '#CCD8E5',
  veryHighRisk: '#76232f',
  veryHighRisk100: '#76232f',
  veryHighRisk50: '#B18A91',
  highRisk: '#da291c',
  highRisk100: '#da291c',
  highRisk50: '#ED918A',
  mediumRisk: '#ffd700',
  mediumRisk100: '#ffd700',
  mediumRisk50: '#FBEA82',
  lowRisk: '#509e2f',
  lowRisk100: '#509e2f',
  lowRisk50: '#9CCF9A',
  positive: '#509e2f',
  negative: '#da291c',
  warning: '#ffd700',
  info: '#00a9e4',
  dark: '#1d1d1d',
  white: '#ffffff',
  black: '#000000',
  grey: '#808080',
  red: '#FF0000',
  green: '#00FF00',
  blue: '#0000FF',
  yellow: '#FFFF00',
  cyan: '#00FFFF',
  magenta: '#FF00FF',
  orange: '#FFA500',
  purple: '#800080',
  chart01: '#C83961',
  chart01_100: '#4c1625',
  chart01_90: '#6c1f34',
  chart01_80: '#8e2845',
  chart01_70: '#b13256',
  chart01_60: '#cc476c',
  chart01_50: '#d66a88',
  chart01_40: '#de89a1',
  chart01_30: '#e7a8b9',
  chart01_20: '#efc5d1',
  chart01_10: '#f7e2e8',
  chart02: '#F3873D',
  chart02_100: '#3e2210',
  chart02_90: '#593116',
  chart02_80: '#75411d',
  chart02_70: '#935225',
  chart02_60: '#b1632d',
  chart02_50: '#d17434',
  chart02_40: '#f1863d',
  chart02_30: '#f6a770',
  chart02_20: '#f9c5a2',
  chart02_10: '#fce2d1',
  chart03: '#F1B434',
  chart03_100: '#34270b',
  chart03_90: '#4b3810',
  chart03_80: '#644a15',
  chart03_70: '#7d5d1b',
  chart03_60: '#977121',
  chart03_50: '#b28526',
  chart03_40: '#ce9a2c',
  chart03_30: '#eaaf32',
  chart03_20: '#f5ca6f',
  chart03_10: '#fae5b9',
  chart04: '#A0B03C',
  chart04_100: '#272b0f',
  chart04_90: '#393e15',
  chart04_80: '#4b531c',
  chart04_70: '#5e6723',
  chart04_60: '#727d2b',
  chart04_50: '#869332',
  chart04_40: '#9baa3a',
  chart04_30: '#b3c064',
  chart04_20: '#cdd597',
  chart04_10: '#e6eacb',
  chart05: '#59A15A',
  chart05_100: '#192e1a',
  chart05_90: '#254225',
  chart05_80: '#305731',
  chart05_70: '#3c6d3d',
  chart05_60: '#49844a',
  chart05_50: '#569c57',
  chart05_40: '#74b075',
  chart05_30: '#97c497',
  chart05_20: '#b9d8ba',
  chart05_10: '#dcebdc',
  chart06: '#007377',
  chart06_100: '#002f30',
  chart06_90: '#004345',
  chart06_80: '#00585b',
  chart06_70: '#006e71',
  chart06_60: '#1e8487',
  chart06_50: '#45999c',
  chart06_40: '#6aadb0',
  chart06_30: '#8fc2c3',
  chart06_20: '#b4d6d7',
  chart06_10: '#daeaeb',
  chart07: '#326295',
  chart07_100: '#162a41',
  chart07_90: '#1f3d5d',
  chart07_80: '#29507a',
  chart07_70: '#366597',
  chart07_60: '#517aa5',
  chart07_50: '#6d8fb4',
  chart07_40: '#8aa5c2',
  chart07_30: '#a6bbd1',
  chart07_20: '#c3d1e0',
  chart07_10: '#e1e8ef',
  chart08: '#6A4D94',
  chart08_100: '#302343',
  chart08_90: '#453260',
  chart08_80: '#5b427f',
  chart08_70: '#715599',
  chart08_60: '#846ca7',
  chart08_50: '#9883b5',
  chart08_40: '#ac9bc3',
  chart08_30: '#c0b4d2',
  chart08_20: '#d5cce0',
  chart08_10: '#eae5f0',
  chart09: '#9C266E',
  chart09_100: '#4c1235',
  chart09_90: '#6b1a4c',
  chart09_80: '#8d2263',
  chart09_70: '#a5397b',
  chart09_60: '#b3578f',
  chart09_50: '#c074a2',
  chart09_40: '#cc90b5',
  chart09_30: '#d9acc7',
  chart09_20: '#e6c7da',
  chart09_10: '#f2e3ec',
  chart10: '#F1B434',
  chart10_91: '#b13256',
  chart10_84: '#c3545a',
  chart10_77: '#d27464',
  chart10_70: '#de9373',
  chart10_63: '#e9b189',
  chart10_56: '#f3cfa4',
  chart10_49: '#ffebc4',
  chart10_42: '#e5d9aa',
  chart10_35: '#c9c792',
  chart10_28: '#acb67c',
  chart10_21: '#8da569',
  chart10_14: '#6c9458',
  chart10_07: '#49844a',
  // Risk severity ramp: _50 Very High → _10 Very Low.
  chart11: '#B13256',
  chart11_100: '#4A1427',
  chart11_90: '#5E1A30',
  chart11_80: '#722039',
  chart11_70: '#872642',
  chart11_60: '#9C2C4B',
  chart11_50: '#B13256',
  chart11_40: '#D27464',
  chart11_30: '#E9B189',
  chart11_20: '#C9C792',
  chart11_10: '#8DA569',
  grey_100: '#292929',
  grey_90: '#3b3b3b',
  grey_80: '#4e4e4e',
  grey_70: '#626262',
  grey_60: '#777777',
  grey_50: '#8c8c8c',
  grey_40: '#a2a2a2',
  grey_30: '#b9b9b9',
  grey_20: '#d0d0d0',
  grey_10: '#e7e7e7',
  // Arcadis Brand Colors — D1 (2026-07-28): re-pointed to the Luma brand ramp (spec §3.3)
  brand50: '#fff2eb',
  brand100: '#ffe2d1',
  brand200: '#ffbb94',
  brand400: '#ff9052',
  brand500: '#ff5c00',
  brand600: '#c24600',
  brand700: '#a83d00',
  brand900: '#752a00',
  // Neutral Colors
  neutral0: '#ffffff',
  neutral25: '#fcfcfc',
  neutral50: '#f8f8f8',
  neutral100: '#f4f4f4',
  neutral200: '#e1e0e0',
  neutral400: '#c2c1c1',
  neutral500: '#868484',
  neutral600: '#494646',
  neutral700: '#2d2929',
  neutral900: '#0c0808',
  neutral900_opacity: 'rgba(12, 8, 8, 0.8)',
  // Success Colors
  success25: '#f5f9f4',
  success50: '#ecf3e9',
  success100: '#d8e7d2',
  success200: '#9ec38f',
  success400: '#649e4c',
  success500: '#3d861f',
  success600: '#34721a',
  success700: '#2b5e16',
  success900: '#1f4310',
  // Info Colors
  info25: '#f2f7fd',
  info50: '#e5eefc',
  info100: '#ccdef9',
  info200: '#80acf0',
  info400: '#337be7',
  info500: '#005ae1',
  info600: '#004dbf',
  info700: '#003f9d',
  info900: '#002d71',
  // Error Colors
  error25: '#fdf4f4',
  error50: '#fbeae8',
  error100: '#f8d4d2',
  error200: '#ed948d',
  error400: '#e15449',
  error500: '#da291c',
  error600: '#b92318',
  error700: '#991d14',
  error900: '#6d150e',
  // Warning Colors
  warning25: '#fefbf5',
  warning50: '#fef8ea',
  warning100: '#fdf1d5',
  warning200: '#f9dc96',
  warning400: '#f6c758',
  warning500: '#f4b92e',
  warning600: '#cf9d27',
  warning700: '#af7c03',
  warning900: '#7d5902',
  // Special Colors
  special25: '#faf4f8',
  special50: '#f5e9f0',
  special100: '#ebd4e2',
  special200: '#cd92b6',
  special400: '#b0518b',
  special500: '#9c266e',
  special600: '#85205e',
  special700: '#6d1b4d',
  special900: '#4e1337'
}

/** Nexus palette used for the BarTile swapped-axis breakdown series. */
export const NEXUS_PALETTE = [
  paletteColors.chart07_50,
  paletteColors.chart09_80,
  paletteColors.chart01_50,
  paletteColors.chart02_90,
  paletteColors.chart03_70,
  paletteColors.chart04_50,
  paletteColors.chart05_60,
  paletteColors.chart06_90,
  paletteColors.chart08_70
] as const

export const allColors = Object.values(paletteColors)

export const colorsByHue = [
  {
    name: 'heritage',
    label: 'Heritage',
    value: paletteColors.heritage,
    tints: [
      {
        name: 'heritage100',
        label: 'Heritage 100',
        value: paletteColors.heritage100,
        percentage: 100
      },
      {
        name: 'heritage75',
        label: 'Heritage 75',
        value: paletteColors.heritage75,
        percentage: 75
      },
      {
        name: 'heritage50',
        label: 'Heritage 50',
        value: paletteColors.heritage50,
        percentage: 50
      },
      {
        name: 'heritage25',
        label: 'Heritage 25',
        value: paletteColors.heritage25,
        percentage: 25
      }
    ]
  },
  {
    name: 'confidence',
    label: 'Confidence',
    value: paletteColors.confidence,
    tints: [
      {
        name: 'confidence100',
        label: 'Confidence 100',
        value: paletteColors.confidence100,
        percentage: 100
      },
      {
        name: 'confidence75',
        label: 'Confidence 75',
        value: paletteColors.confidence75,
        percentage: 75
      },
      {
        name: 'confidence50',
        label: 'Confidence 50',
        value: paletteColors.confidence50,
        percentage: 50
      },
      {
        name: 'confidence25',
        label: 'Confidence 25',
        value: paletteColors.confidence25,
        percentage: 25
      }
    ]
  },
  {
    name: 'collaboration',
    label: 'Collaboration',
    value: paletteColors.collaboration,
    tints: [
      {
        name: 'collaboration100',
        label: 'Collaboration 100',
        value: paletteColors.collaboration100,
        percentage: 100
      },
      {
        name: 'collaboration75',
        label: 'Collaboration 75',
        value: paletteColors.collaboration75,
        percentage: 75
      },
      {
        name: 'collaboration50',
        label: 'Collaboration 50',
        value: paletteColors.collaboration50,
        percentage: 50
      },
      {
        name: 'collaboration25',
        label: 'Collaboration 25',
        value: paletteColors.collaboration25,
        percentage: 25
      }
    ]
  },
  {
    name: 'clientsuccess',
    label: 'Client success',
    value: paletteColors.clientsuccess,
    tints: [
      {
        name: 'clientsuccess100',
        label: 'Client success 100',
        value: paletteColors.clientsuccess100,
        percentage: 100
      },
      {
        name: 'clientsuccess75',
        label: 'Client success 75',
        value: paletteColors.clientsuccess75,
        percentage: 75
      },
      {
        name: 'clientsuccess50',
        label: 'Client success 50',
        value: paletteColors.clientsuccess50,
        percentage: 50
      },
      {
        name: 'clientsuccess25',
        label: 'Client success 25',
        value: paletteColors.clientsuccess25,
        percentage: 25
      }
    ]
  },
  {
    name: 'sustainability',
    label: 'Sustainability',
    value: paletteColors.sustainability,
    tints: [
      {
        name: 'sustainability100',
        label: 'Sustainability 100',
        value: paletteColors.sustainability100,
        percentage: 100
      },
      {
        name: 'sustainability75',
        label: 'Sustainability 75',
        value: paletteColors.sustainability75,
        percentage: 75
      },
      {
        name: 'sustainability50',
        label: 'Sustainability 50',
        value: paletteColors.sustainability50,
        percentage: 50
      },
      {
        name: 'sustainability25',
        label: 'Sustainability 25',
        value: paletteColors.sustainability25,
        percentage: 25
      }
    ]
  },
  {
    name: 'integrity',
    label: 'Integrity',
    value: paletteColors.integrity,
    tints: [
      {
        name: 'integrity100',
        label: 'Integrity 100',
        value: paletteColors.integrity100,
        percentage: 100
      },
      {
        name: 'integrity75',
        label: 'Integrity 75',
        value: paletteColors.integrity75,
        percentage: 75
      },
      {
        name: 'integrity50',
        label: 'Integrity 50',
        value: paletteColors.integrity50,
        percentage: 50
      },
      {
        name: 'integrity25',
        label: 'Integrity 25',
        value: paletteColors.integrity25,
        percentage: 25
      }
    ]
  },
  {
    name: 'veryHighRisk',
    label: 'Very high risk',
    value: paletteColors.veryHighRisk,
    tints: [
      {
        name: 'veryHighRisk100',
        label: 'Very high risk 100',
        value: paletteColors.veryHighRisk100,
        percentage: 100
      },
      {
        name: 'veryHighRisk100',
        label: 'Very high risk 100',
        value: paletteColors.veryHighRisk100,
        percentage: 100
      },
      {
        name: 'veryHighRisk50',
        label: 'Very high risk 50',
        value: paletteColors.veryHighRisk50,
        percentage: 50
      },
      {
        name: 'veryHighRisk50',
        label: 'Very high risk 50',
        value: paletteColors.veryHighRisk50,
        percentage: 50
      }
    ]
  },
  {
    name: 'highRisk',
    label: 'High risk',
    value: paletteColors.highRisk,
    tints: [
      {
        name: 'highRisk100',
        label: 'High risk 100',
        value: paletteColors.highRisk100,
        percentage: 100
      },
      {
        name: 'highRisk100',
        label: 'High risk 100',
        value: paletteColors.highRisk100,
        percentage: 100
      },
      {
        name: 'highRisk50',
        label: 'High risk 50',
        value: paletteColors.highRisk50,
        percentage: 50
      },
      {
        name: 'highRisk50',
        label: 'High risk 50',
        value: paletteColors.highRisk50,
        percentage: 50
      }
    ]
  },
  {
    name: 'mediumRisk',
    label: 'Medium risk',
    value: paletteColors.mediumRisk,
    tints: [
      {
        name: 'mediumRisk100',
        label: 'Medium risk 100',
        value: paletteColors.mediumRisk100,
        percentage: 100
      },
      {
        name: 'mediumRisk100',
        label: 'Medium risk 100',
        value: paletteColors.mediumRisk100,
        percentage: 100
      },
      {
        name: 'mediumRisk50',
        label: 'Medium risk 50',
        value: paletteColors.mediumRisk50,
        percentage: 50
      },
      {
        name: 'mediumRisk50',
        label: 'Medium risk 50',
        value: paletteColors.mediumRisk50,
        percentage: 50
      }
    ]
  },
  {
    name: 'lowRisk',
    label: 'Low risk',
    value: paletteColors.lowRisk,
    tints: [
      {
        name: 'lowRisk100',
        label: 'Low risk 100',
        value: paletteColors.lowRisk100,
        percentage: 100
      },
      {
        name: 'lowRisk100',
        label: 'Low risk 100',
        value: paletteColors.lowRisk100,
        percentage: 100
      },
      {
        name: 'lowRisk50',
        label: 'Low risk 50',
        value: paletteColors.lowRisk50,
        percentage: 50
      },
      {
        name: 'lowRisk50',
        label: 'Low risk 50',
        value: paletteColors.lowRisk50,
        percentage: 50
      }
    ]
  },
  {
    name: 'chart01',
    label: 'Chart 01',
    value: paletteColors.chart01,
    tints: [
      {
        name: 'chart01_100',
        label: 'Chart 01 100',
        value: paletteColors.chart01_100,
        percentage: 100
      },
      {
        name: 'chart01_90',
        label: 'Chart 01 90',
        value: paletteColors.chart01_90,
        percentage: 90
      },
      {
        name: 'chart01_80',
        label: 'Chart 01 80',
        value: paletteColors.chart01_80,
        percentage: 80
      },
      {
        name: 'chart01_70',
        label: 'Chart 01 70',
        value: paletteColors.chart01_70,
        percentage: 70
      },
      {
        name: 'chart01_60',
        label: 'Chart 01 60',
        value: paletteColors.chart01_60,
        percentage: 60
      },
      {
        name: 'chart01_50',
        label: 'Chart 01 50',
        value: paletteColors.chart01_50,
        percentage: 50
      },
      {
        name: 'chart01_40',
        label: 'Chart 01 40',
        value: paletteColors.chart01_40,
        percentage: 40
      },
      {
        name: 'chart01_30',
        label: 'Chart 01 30',
        value: paletteColors.chart01_30,
        percentage: 30
      },
      {
        name: 'chart01_20',
        label: 'Chart 01 20',
        value: paletteColors.chart01_20,
        percentage: 20
      },
      {
        name: 'chart01_10',
        label: 'Chart 01 10',
        value: paletteColors.chart01_10,
        percentage: 10
      }
    ]
  },
  {
    name: 'chart02',
    label: 'Chart 02',
    value: paletteColors.chart02,
    tints: [
      {
        name: 'chart02_100',
        label: 'Chart 02 100',
        value: paletteColors.chart02_100,
        percentage: 100
      },
      {
        name: 'chart02_90',
        label: 'Chart 02 90',
        value: paletteColors.chart02_90,
        percentage: 90
      },
      {
        name: 'chart02_80',
        label: 'Chart 02 80',
        value: paletteColors.chart02_80,
        percentage: 80
      },
      {
        name: 'chart02_70',
        label: 'Chart 02 70',
        value: paletteColors.chart02_70,
        percentage: 70
      },
      {
        name: 'chart02_60',
        label: 'Chart 02 60',
        value: paletteColors.chart02_60,
        percentage: 60
      },
      {
        name: 'chart02_50',
        label: 'Chart 02 50',
        value: paletteColors.chart02_50,
        percentage: 50
      },
      {
        name: 'chart02_40',
        label: 'Chart 02 40',
        value: paletteColors.chart02_40,
        percentage: 40
      },
      {
        name: 'chart02_30',
        label: 'Chart 02 30',
        value: paletteColors.chart02_30,
        percentage: 30
      },
      {
        name: 'chart02_20',
        label: 'Chart 02 20',
        value: paletteColors.chart02_20,
        percentage: 20
      },
      {
        name: 'chart02_10',
        label: 'Chart 02 10',
        value: paletteColors.chart02_10,
        percentage: 10
      }
    ]
  },
  {
    name: 'chart03',
    label: 'Chart 03',
    value: paletteColors.chart03,
    tints: [
      {
        name: 'chart03_100',
        label: 'Chart 03 100',
        value: paletteColors.chart03_100,
        percentage: 100
      },
      {
        name: 'chart03_90',
        label: 'Chart 03 90',
        value: paletteColors.chart03_90,
        percentage: 90
      },
      {
        name: 'chart03_80',
        label: 'Chart 03 80',
        value: paletteColors.chart03_80,
        percentage: 80
      },
      {
        name: 'chart03_70',
        label: 'Chart 03 70',
        value: paletteColors.chart03_70,
        percentage: 70
      },
      {
        name: 'chart03_60',
        label: 'Chart 03 60',
        value: paletteColors.chart03_60,
        percentage: 60
      },
      {
        name: 'chart03_50',
        label: 'Chart 03 50',
        value: paletteColors.chart03_50,
        percentage: 50
      },
      {
        name: 'chart03_40',
        label: 'Chart 03 40',
        value: paletteColors.chart03_40,
        percentage: 40
      },
      {
        name: 'chart03_30',
        label: 'Chart 03 30',
        value: paletteColors.chart03_30,
        percentage: 30
      },
      {
        name: 'chart03_20',
        label: 'Chart 03 20',
        value: paletteColors.chart03_20,
        percentage: 20
      },
      {
        name: 'chart03_10',
        label: 'Chart 03 10',
        value: paletteColors.chart03_10,
        percentage: 10
      }
    ]
  },
  {
    name: 'chart04',
    label: 'Chart 04',
    value: paletteColors.chart04,
    tints: [
      {
        name: 'chart04_100',
        label: 'Chart 04 100',
        value: paletteColors.chart04_100,
        percentage: 100
      },
      {
        name: 'chart04_90',
        label: 'Chart 04 90',
        value: paletteColors.chart04_90,
        percentage: 90
      },
      {
        name: 'chart04_80',
        label: 'Chart 04 80',
        value: paletteColors.chart04_80,
        percentage: 80
      },
      {
        name: 'chart04_70',
        label: 'Chart 04 70',
        value: paletteColors.chart04_70,
        percentage: 70
      },
      {
        name: 'chart04_60',
        label: 'Chart 04 60',
        value: paletteColors.chart04_60,
        percentage: 60
      },
      {
        name: 'chart04_50',
        label: 'Chart 04 50',
        value: paletteColors.chart04_50,
        percentage: 50
      },
      {
        name: 'chart04_40',
        label: 'Chart 04 40',
        value: paletteColors.chart04_40,
        percentage: 40
      },
      {
        name: 'chart04_30',
        label: 'Chart 04 30',
        value: paletteColors.chart04_30,
        percentage: 30
      },
      {
        name: 'chart04_20',
        label: 'Chart 04 20',
        value: paletteColors.chart04_20,
        percentage: 20
      },
      {
        name: 'chart04_10',
        label: 'Chart 04 10',
        value: paletteColors.chart04_10,
        percentage: 10
      }
    ]
  },
  {
    name: 'chart05',
    label: 'Chart 05',
    value: paletteColors.chart05,
    tints: [
      {
        name: 'chart05_100',
        label: 'Chart 05 100',
        value: paletteColors.chart05_100,
        percentage: 100
      },
      {
        name: 'chart05_90',
        label: 'Chart 05 90',
        value: paletteColors.chart05_90,
        percentage: 90
      },
      {
        name: 'chart05_80',
        label: 'Chart 05 80',
        value: paletteColors.chart05_80,
        percentage: 80
      },
      {
        name: 'chart05_70',
        label: 'Chart 05 70',
        value: paletteColors.chart05_70,
        percentage: 70
      },
      {
        name: 'chart05_60',
        label: 'Chart 05 60',
        value: paletteColors.chart05_60,
        percentage: 60
      },
      {
        name: 'chart05_50',
        label: 'Chart 05 50',
        value: paletteColors.chart05_50,
        percentage: 50
      },
      {
        name: 'chart05_40',
        label: 'Chart 05 40',
        value: paletteColors.chart05_40,
        percentage: 40
      },
      {
        name: 'chart05_30',
        label: 'Chart 05 30',
        value: paletteColors.chart05_30,
        percentage: 30
      },
      {
        name: 'chart05_20',
        label: 'Chart 05 20',
        value: paletteColors.chart05_20,
        percentage: 20
      },
      {
        name: 'chart05_10',
        label: 'Chart 05 10',
        value: paletteColors.chart05_10,
        percentage: 10
      }
    ]
  },
  {
    name: 'chart06',
    label: 'Chart 06',
    value: paletteColors.chart06,
    tints: [
      {
        name: 'chart06_100',
        label: 'Chart 06 100',
        value: paletteColors.chart06_100,
        percentage: 100
      },
      {
        name: 'chart06_90',
        label: 'Chart 06 90',
        value: paletteColors.chart06_90,
        percentage: 90
      },
      {
        name: 'chart06_80',
        label: 'Chart 06 80',
        value: paletteColors.chart06_80,
        percentage: 80
      },
      {
        name: 'chart06_70',
        label: 'Chart 06 70',
        value: paletteColors.chart06_70,
        percentage: 70
      },
      {
        name: 'chart06_60',
        label: 'Chart 06 60',
        value: paletteColors.chart06_60,
        percentage: 60
      },
      {
        name: 'chart06_50',
        label: 'Chart 06 50',
        value: paletteColors.chart06_50,
        percentage: 50
      },
      {
        name: 'chart06_40',
        label: 'Chart 06 40',
        value: paletteColors.chart06_40,
        percentage: 40
      },
      {
        name: 'chart06_30',
        label: 'Chart 06 30',
        value: paletteColors.chart06_30,
        percentage: 30
      },
      {
        name: 'chart06_20',
        label: 'Chart 06 20',
        value: paletteColors.chart06_20,
        percentage: 20
      },
      {
        name: 'chart06_10',
        label: 'Chart 06 10',
        value: paletteColors.chart06_10,
        percentage: 10
      }
    ]
  },
  {
    name: 'chart07',
    label: 'Chart 07',
    value: paletteColors.chart07,
    tints: [
      {
        name: 'chart07_100',
        label: 'Chart 07 100',
        value: paletteColors.chart07_100,
        percentage: 100
      },
      {
        name: 'chart07_90',
        label: 'Chart 07 90',
        value: paletteColors.chart07_90,
        percentage: 90
      },
      {
        name: 'chart07_80',
        label: 'Chart 07 80',
        value: paletteColors.chart07_80,
        percentage: 80
      },
      {
        name: 'chart07_70',
        label: 'Chart 07 70',
        value: paletteColors.chart07_70,
        percentage: 70
      },
      {
        name: 'chart07_60',
        label: 'Chart 07 60',
        value: paletteColors.chart07_60,
        percentage: 60
      },
      {
        name: 'chart07_50',
        label: 'Chart 07 50',
        value: paletteColors.chart07_50,
        percentage: 50
      },
      {
        name: 'chart07_40',
        label: 'Chart 07 40',
        value: paletteColors.chart07_40,
        percentage: 40
      },
      {
        name: 'chart07_30',
        label: 'Chart 07 30',
        value: paletteColors.chart07_30,
        percentage: 30
      },
      {
        name: 'chart07_20',
        label: 'Chart 07 20',
        value: paletteColors.chart07_20,
        percentage: 20
      },
      {
        name: 'chart07_10',
        label: 'Chart 07 10',
        value: paletteColors.chart07_10,
        percentage: 10
      }
    ]
  },
  {
    name: 'chart08',
    label: 'Chart 08',
    value: paletteColors.chart08,
    tints: [
      {
        name: 'chart08_100',
        label: 'Chart 08 100',
        value: paletteColors.chart08_100,
        percentage: 100
      },
      {
        name: 'chart08_90',
        label: 'Chart 08 90',
        value: paletteColors.chart08_90,
        percentage: 90
      },
      {
        name: 'chart08_80',
        label: 'Chart 08 80',
        value: paletteColors.chart08_80,
        percentage: 80
      },
      {
        name: 'chart08_70',
        label: 'Chart 08 70',
        value: paletteColors.chart08_70,
        percentage: 70
      },
      {
        name: 'chart08_60',
        label: 'Chart 08 60',
        value: paletteColors.chart08_60,
        percentage: 60
      },
      {
        name: 'chart08_50',
        label: 'Chart 08 50',
        value: paletteColors.chart08_50,
        percentage: 50
      },
      {
        name: 'chart08_40',
        label: 'Chart 08 40',
        value: paletteColors.chart08_40,
        percentage: 40
      },
      {
        name: 'chart08_30',
        label: 'Chart 08 30',
        value: paletteColors.chart08_30,
        percentage: 30
      },
      {
        name: 'chart08_20',
        label: 'Chart 08 20',
        value: paletteColors.chart08_20,
        percentage: 20
      },
      {
        name: 'chart08_10',
        label: 'Chart 08 10',
        value: paletteColors.chart08_10,
        percentage: 10
      }
    ]
  },
  {
    name: 'chart09',
    label: 'Chart 09',
    value: paletteColors.chart09,
    tints: [
      {
        name: 'chart09_100',
        label: 'Chart 09 100',
        value: paletteColors.chart09_100,
        percentage: 100
      },
      {
        name: 'chart09_90',
        label: 'Chart 09 90',
        value: paletteColors.chart09_90,
        percentage: 90
      },
      {
        name: 'chart09_80',
        label: 'Chart 09 80',
        value: paletteColors.chart09_80,
        percentage: 80
      },
      {
        name: 'chart09_70',
        label: 'Chart 09 70',
        value: paletteColors.chart09_70,
        percentage: 70
      },
      {
        name: 'chart09_60',
        label: 'Chart 09 60',
        value: paletteColors.chart09_60,
        percentage: 60
      },
      {
        name: 'chart09_50',
        label: 'Chart 09 50',
        value: paletteColors.chart09_50,
        percentage: 50
      },
      {
        name: 'chart09_40',
        label: 'Chart 09 40',
        value: paletteColors.chart09_40,
        percentage: 40
      },
      {
        name: 'chart09_30',
        label: 'Chart 09 30',
        value: paletteColors.chart09_30,
        percentage: 30
      },
      {
        name: 'chart09_20',
        label: 'Chart 09 20',
        value: paletteColors.chart09_20,
        percentage: 20
      },
      {
        name: 'chart09_10',
        label: 'Chart 09 10',
        value: paletteColors.chart09_10,
        percentage: 10
      }
    ]
  },
  {
    name: 'chart10',
    label: 'Chart 10',
    value: paletteColors.chart10,
    tints: [
      {
        name: 'chart10_91',
        label: 'Chart 10 91',
        value: paletteColors.chart10_91,
        percentage: 91
      },
      {
        name: 'chart10_84',
        label: 'Chart 10 84',
        value: paletteColors.chart10_84,
        percentage: 84
      },
      {
        name: 'chart10_77',
        label: 'Chart 10 77',
        value: paletteColors.chart10_77,
        percentage: 77
      },
      {
        name: 'chart10_70',
        label: 'Chart 10 70',
        value: paletteColors.chart10_70,
        percentage: 70
      },
      {
        name: 'chart10_63',
        label: 'Chart 10 63',
        value: paletteColors.chart10_63,
        percentage: 63
      },
      {
        name: 'chart10_56',
        label: 'Chart 10 56',
        value: paletteColors.chart10_56,
        percentage: 56
      },
      {
        name: 'chart10_49',
        label: 'Chart 10 49',
        value: paletteColors.chart10_49,
        percentage: 49
      },
      {
        name: 'chart10_42',
        label: 'Chart 10 42',
        value: paletteColors.chart10_42,
        percentage: 42
      },
      {
        name: 'chart10_35',
        label: 'Chart 10 35',
        value: paletteColors.chart10_35,
        percentage: 35
      },
      {
        name: 'chart10_28',
        label: 'Chart 10 28',
        value: paletteColors.chart10_28,
        percentage: 28
      },
      {
        name: 'chart10_21',
        label: 'Chart 10 21',
        value: paletteColors.chart10_21,
        percentage: 21
      },
      {
        name: 'chart10_14',
        label: 'Chart 10 14',
        value: paletteColors.chart10_14,
        percentage: 14
      },
      {
        name: 'chart10_7',
        label: 'Chart 10 7',
        value: paletteColors.chart10_07,
        percentage: 7
      }
    ]
  },
  {
    name: 'chart11',
    label: 'Chart 11',
    value: paletteColors.chart11,
    tints: [
      {
        name: 'chart11_100',
        label: 'Chart 11 100',
        value: paletteColors.chart11_100,
        percentage: 100
      },
      {
        name: 'chart11_90',
        label: 'Chart 11 90',
        value: paletteColors.chart11_90,
        percentage: 90
      },
      {
        name: 'chart11_80',
        label: 'Chart 11 80',
        value: paletteColors.chart11_80,
        percentage: 80
      },
      {
        name: 'chart11_70',
        label: 'Chart 11 70',
        value: paletteColors.chart11_70,
        percentage: 70
      },
      {
        name: 'chart11_60',
        label: 'Chart 11 60',
        value: paletteColors.chart11_60,
        percentage: 60
      },
      {
        name: 'chart11_50',
        label: 'Chart 11 50',
        value: paletteColors.chart11_50,
        percentage: 50
      },
      {
        name: 'chart11_40',
        label: 'Chart 11 40',
        value: paletteColors.chart11_40,
        percentage: 40
      },
      {
        name: 'chart11_30',
        label: 'Chart 11 30',
        value: paletteColors.chart11_30,
        percentage: 30
      },
      {
        name: 'chart11_20',
        label: 'Chart 11 20',
        value: paletteColors.chart11_20,
        percentage: 20
      },
      {
        name: 'chart11_10',
        label: 'Chart 11 10',
        value: paletteColors.chart11_10,
        percentage: 10
      }
    ]
  },
  {
    name: 'grey',
    label: 'Grey',
    value: paletteColors.grey_100,
    tints: [
      {
        name: 'grey_100',
        label: 'Grey 100',
        value: paletteColors.grey_100,
        percentage: 100
      },
      {
        name: 'grey_90',
        label: 'Grey 90',
        value: paletteColors.grey_90,
        percentage: 90
      },
      {
        name: 'grey_80',
        label: 'Grey 80',
        value: paletteColors.grey_80,
        percentage: 80
      },
      {
        name: 'grey_70',
        label: 'Grey 70',
        value: paletteColors.grey_70,
        percentage: 70
      },
      {
        name: 'grey_60',
        label: 'Grey 60',
        value: paletteColors.grey_60,
        percentage: 60
      },
      {
        name: 'grey_50',
        label: 'Grey 50',
        value: paletteColors.grey_50,
        percentage: 50
      },
      {
        name: 'grey_40',
        label: 'Grey 40',
        value: paletteColors.grey_40,
        percentage: 40
      },
      {
        name: 'grey_30',
        label: 'Grey 30',
        value: paletteColors.grey_30,
        percentage: 30
      },
      {
        name: 'grey_20',
        label: 'Grey 20',
        value: paletteColors.grey_20,
        percentage: 20
      },
      {
        name: 'grey_10',
        label: 'Grey 10',
        value: paletteColors.grey_10,
        percentage: 10
      }
    ]
  },
  // Arcadis Brand Colors
  {
    name: 'brand',
    label: 'Brand',
    value: paletteColors.brand500,
    tints: [
      { name: 'brand50', label: 'Brand 50', value: paletteColors.brand50, percentage: 50 },
      { name: 'brand100', label: 'Brand 100', value: paletteColors.brand100, percentage: 100 },
      { name: 'brand200', label: 'Brand 200', value: paletteColors.brand200, percentage: 200 },
      { name: 'brand400', label: 'Brand 400', value: paletteColors.brand400, percentage: 400 },
      { name: 'brand500', label: 'Brand 500', value: paletteColors.brand500, percentage: 500 },
      { name: 'brand600', label: 'Brand 600', value: paletteColors.brand600, percentage: 600 },
      { name: 'brand700', label: 'Brand 700', value: paletteColors.brand700, percentage: 700 },
      { name: 'brand900', label: 'Brand 900', value: paletteColors.brand900, percentage: 900 }
    ]
  },
  // Neutral Colors
  {
    name: 'neutral',
    label: 'Neutral',
    value: paletteColors.neutral500,
    tints: [
      { name: 'neutral0', label: 'Neutral 0', value: paletteColors.neutral0, percentage: 0 },
      { name: 'neutral25', label: 'Neutral 25', value: paletteColors.neutral25, percentage: 25 },
      { name: 'neutral50', label: 'Neutral 50', value: paletteColors.neutral50, percentage: 50 },
      {
        name: 'neutral100',
        label: 'Neutral 100',
        value: paletteColors.neutral100,
        percentage: 100
      },
      {
        name: 'neutral200',
        label: 'Neutral 200',
        value: paletteColors.neutral200,
        percentage: 200
      },
      {
        name: 'neutral400',
        label: 'Neutral 400',
        value: paletteColors.neutral400,
        percentage: 400
      },
      {
        name: 'neutral500',
        label: 'Neutral 500',
        value: paletteColors.neutral500,
        percentage: 500
      },
      {
        name: 'neutral600',
        label: 'Neutral 600',
        value: paletteColors.neutral600,
        percentage: 600
      },
      {
        name: 'neutral700',
        label: 'Neutral 700',
        value: paletteColors.neutral700,
        percentage: 700
      },
      {
        name: 'neutral900',
        label: 'Neutral 900',
        value: paletteColors.neutral900,
        percentage: 900
      },
      {
        name: 'neutral900_opacity',
        label: 'Neutral 900 Opacity',
        value: paletteColors.neutral900_opacity,
        percentage: 900
      }
    ]
  },
  // Success Colors
  {
    name: 'success',
    label: 'Success',
    value: paletteColors.success500,
    tints: [
      { name: 'success25', label: 'Success 25', value: paletteColors.success25, percentage: 25 },
      { name: 'success50', label: 'Success 50', value: paletteColors.success50, percentage: 50 },
      {
        name: 'success100',
        label: 'Success 100',
        value: paletteColors.success100,
        percentage: 100
      },
      {
        name: 'success200',
        label: 'Success 200',
        value: paletteColors.success200,
        percentage: 200
      },
      {
        name: 'success400',
        label: 'Success 400',
        value: paletteColors.success400,
        percentage: 400
      },
      {
        name: 'success500',
        label: 'Success 500',
        value: paletteColors.success500,
        percentage: 500
      },
      {
        name: 'success600',
        label: 'Success 600',
        value: paletteColors.success600,
        percentage: 600
      },
      {
        name: 'success700',
        label: 'Success 700',
        value: paletteColors.success700,
        percentage: 700
      },
      { name: 'success900', label: 'Success 900', value: paletteColors.success900, percentage: 900 }
    ]
  },
  // Info Colors
  {
    name: 'info',
    label: 'Info',
    value: paletteColors.info500,
    tints: [
      { name: 'info25', label: 'Info 25', value: paletteColors.info25, percentage: 25 },
      { name: 'info50', label: 'Info 50', value: paletteColors.info50, percentage: 50 },
      { name: 'info100', label: 'Info 100', value: paletteColors.info100, percentage: 100 },
      { name: 'info200', label: 'Info 200', value: paletteColors.info200, percentage: 200 },
      { name: 'info400', label: 'Info 400', value: paletteColors.info400, percentage: 400 },
      { name: 'info500', label: 'Info 500', value: paletteColors.info500, percentage: 500 },
      { name: 'info600', label: 'Info 600', value: paletteColors.info600, percentage: 600 },
      { name: 'info700', label: 'Info 700', value: paletteColors.info700, percentage: 700 },
      { name: 'info900', label: 'Info 900', value: paletteColors.info900, percentage: 900 }
    ]
  },
  // Error Colors
  {
    name: 'error',
    label: 'Error',
    value: paletteColors.error500,
    tints: [
      { name: 'error25', label: 'Error 25', value: paletteColors.error25, percentage: 25 },
      { name: 'error50', label: 'Error 50', value: paletteColors.error50, percentage: 50 },
      { name: 'error100', label: 'Error 100', value: paletteColors.error100, percentage: 100 },
      { name: 'error200', label: 'Error 200', value: paletteColors.error200, percentage: 200 },
      { name: 'error400', label: 'Error 400', value: paletteColors.error400, percentage: 400 },
      { name: 'error500', label: 'Error 500', value: paletteColors.error500, percentage: 500 },
      { name: 'error600', label: 'Error 600', value: paletteColors.error600, percentage: 600 },
      { name: 'error700', label: 'Error 700', value: paletteColors.error700, percentage: 700 },
      { name: 'error900', label: 'Error 900', value: paletteColors.error900, percentage: 900 }
    ]
  },
  // Warning Colors
  {
    name: 'warning',
    label: 'Warning',
    value: paletteColors.warning500,
    tints: [
      { name: 'warning25', label: 'Warning 25', value: paletteColors.warning25, percentage: 25 },
      { name: 'warning50', label: 'Warning 50', value: paletteColors.warning50, percentage: 50 },
      {
        name: 'warning100',
        label: 'Warning 100',
        value: paletteColors.warning100,
        percentage: 100
      },
      {
        name: 'warning200',
        label: 'Warning 200',
        value: paletteColors.warning200,
        percentage: 200
      },
      {
        name: 'warning400',
        label: 'Warning 400',
        value: paletteColors.warning400,
        percentage: 400
      },
      {
        name: 'warning500',
        label: 'Warning 500',
        value: paletteColors.warning500,
        percentage: 500
      },
      {
        name: 'warning600',
        label: 'Warning 600',
        value: paletteColors.warning600,
        percentage: 600
      },
      {
        name: 'warning700',
        label: 'Warning 700',
        value: paletteColors.warning700,
        percentage: 700
      },
      { name: 'warning900', label: 'Warning 900', value: paletteColors.warning900, percentage: 900 }
    ]
  },
  // Special Colors
  {
    name: 'special',
    label: 'Special',
    value: paletteColors.special500,
    tints: [
      { name: 'special25', label: 'Special 25', value: paletteColors.special25, percentage: 25 },
      { name: 'special50', label: 'Special 50', value: paletteColors.special50, percentage: 50 },
      {
        name: 'special100',
        label: 'Special 100',
        value: paletteColors.special100,
        percentage: 100
      },
      {
        name: 'special200',
        label: 'Special 200',
        value: paletteColors.special200,
        percentage: 200
      },
      {
        name: 'special400',
        label: 'Special 400',
        value: paletteColors.special400,
        percentage: 400
      },
      {
        name: 'special500',
        label: 'Special 500',
        value: paletteColors.special500,
        percentage: 500
      },
      {
        name: 'special600',
        label: 'Special 600',
        value: paletteColors.special600,
        percentage: 600
      },
      {
        name: 'special700',
        label: 'Special 700',
        value: paletteColors.special700,
        percentage: 700
      },
      { name: 'special900', label: 'Special 900', value: paletteColors.special900, percentage: 900 }
    ]
  }
]
